// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import ContactRow from 'components/club/ContactRow';
import { handleTagEvent } from 'utils/tagManagerUtils';
import type { ComiteFunctionType, PratiqueContact } from 'types/Club';
import { ffrName } from 'utils/ffrNameUtils';

type Props = {
  name: string,
  website: string,
  email: string,
  phoneNumber: string,
  contacts: Array<ComiteFunctionType>,
  contacts_pratiques: Array<PratiqueContact>
};

type State = {
  open: boolean
};

class ClubContact extends PureComponent<Props, State> {
  state: State = {
    open: false
  };

  toggleContacts = (e: MouseEvent) => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { website, email, phoneNumber, name } = this.props;

    const classNamesContainer = dynamicClassName('contact mb-6 mb-md-7');
    this.state.open && classNamesContainer.add('is-open');

    const classNamesLink = dynamicClassName(
      'link-chevron link-chevron--block link-chevron--center link-chevron--inline'
    );
    this.state.open && classNamesLink.add('is-open');

    const contacts = [];
    const contacts_pratiques = [];
    const listSize = 3;
    if (this.props.contacts.length > 0) {
      for (let i = 0; i < this.props.contacts.length; i += listSize) {
        contacts.push(this.props.contacts.slice(i, i + listSize));
      }
    }

    if (this.props.contacts_pratiques.length > 0) {
      for (let i = 0; i < this.props.contacts_pratiques.length; i += listSize) {
        contacts_pratiques.push(this.props.contacts_pratiques.slice(i, i + listSize));
      }
    }

    return (
      <div className={classNamesContainer.build()}>
        <div className="box">
          <ul className="contact__club">
            {website && (
              <li className="contact__item">
                <i className="icon icon-site" />
                <p className="ft-h4">
                  <a
                    href={website}
                    title={`Voir le site Internet du club ${ffrName(name)} (nouvel onglet)`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ft-black"
                    onClick={handleTagEvent('module contact', 'clic lien sortant', window.location.pathname)}
                  >
                    Site web du club {ffrName(name)}
                  </a>
                </p>
              </li>
            )}
            {email && (
              <li className="contact__item">
                <i className="icon icon-mail" />
                <p className="ft-h4">Adresse email</p>
                <p>
                  <a
                    href={`mailto:${email}`}
                    title={`Envoyer un email au club ${ffrName(name)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleTagEvent('module contact', 'clic mail', window.location.pathname)}
                  >
                    {email}
                  </a>
                </p>
              </li>
            )}
            {phoneNumber && (
              <li className="contact__item">
                <i className="icon icon-phone" />
                <p className="ft-h4">Téléphone</p>
                <p>
                  <a
                    href={`tel:${phoneNumber}`}
                    title={`Contacter le club ${ffrName(name)} par téléphone`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {phoneNumber}
                  </a>
                </p>
              </li>
            )}
          </ul>
          {(contacts.length > 0 || contacts_pratiques.length > 0) && (
            <div
              style={{cursor: 'pointer'}}
              role="button"
              tabIndex={0}
              onClick={this.toggleContacts}
              title={this.state.open ? 'Masquer les contacts' : 'Afficher les contacts'}
              className={classNamesLink.build()}
              data-label={this.state.open ? 'Masquer les contacts' : 'Afficher les contacts'}
            >
              <span>{this.state.open ? 'Masquer les contacts' : 'Afficher les contacts'}</span>
              <i className="icon icon-zoom_plus" />
            </div>
          )}
        </div>
        {contacts.length > 0 && (
          <div className="contact__more">
            <h3 className="mb-2 ft-400">Direction</h3>
            {contacts.map((contactList, index) => (
              <ul key={'list_contact_' + index} className="contact__staff">
                {contactList.map((contact, index) => (
                  <ContactRow key={index} category={contact.fonction} member={contact.Personne} />
                ))}
              </ul>
            ))}
          </div>
        )}
        {contacts_pratiques.length > 0 && (
          <div className="contact__more">
            <h3 className="mb-2 ft-400">Responsables</h3>
            {contacts_pratiques.map((contacts_pratiquesList, index) => (
              <ul key={'list_contact_pratique_' + index} className="contact__staff">
                {contacts_pratiquesList.map((contact, index) => (
                  <ContactRow key={index} category={contact.fonction.join(', ')} member={contact} />
                ))}
              </ul>
            ))}
          </div>
        )}
      </div>
    );
  }
}
export default ClubContact;
